
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const walletTransService = {
    walletTransByDate, walletSearch,
    walletTransList, walletDetails 
};



async function  walletTransByDate(form) {
    return  apiClient.post(`/wallet/wallet-by-date`, form, authHeader());
}


async function  walletSearch(searchText) {
    return  apiClient.get(`/wallet/wallet-search?search=${searchText}`, authHeader());
}


async function  walletTransList() {
    return  apiClient.get(`/wallet/wallet-list`, authHeader());
}


async function  walletDetails(id) {
    return  apiClient.get(`/wallet/wallet-details/${id}`, authHeader());
}













